import React from 'react';
import PropTypes from 'prop-types';

import { Utr, UtrLabel } from '../../../text';
import { utrTypeIds } from '../../../../utils/eventConstants';
import { MatchFormatTypes } from '../../../../utils/postScoreConstants';

const Rating = props => {
    const { player, ratingType, utrType, ratingStatus, showDecimals, showProjectedViewStatus, hideUtrLabel, sportTypeId, isPickleballRating, isItGlobalSearch, showTypeDots, 'data-testid': dataTestId } = props;
    const doublesPicklebalLabel = player.doublesPkbRatingDisplay?.reliability;
    const singlePicklebalLabel = player.singlesPkbRatingDisplay?.reliability;
    const hideReliableForSinlgePkb = ratingType === MatchFormatTypes.SINGLES && singlePicklebalLabel === 'Reliable';
    const hideReliableForDoublesPkb = ratingType === MatchFormatTypes.DOUBLES && doublesPicklebalLabel === 'Reliable';
    const hideReliableLabelForPkb = hideReliableForSinlgePkb || hideReliableForDoublesPkb;
    return (
        <div className="values" data-testid={dataTestId && `${dataTestId}.values`}>
            <div
                className={`value ${(ratingStatus !== 'Rated' && !hideReliableLabelForPkb) ? 'text-lighter' : ''}`}
                title={(utrType === 'sanctioned' || utrType === utrTypeIds.SANCTIONED) ? ratingStatus : ''}
                data-testid={dataTestId && `${dataTestId}.utr`}
            >
                <Utr player={player} force={{ ratingType, utrType, verifiedIcon: true, showDecimals, showProjectedViewStatus }} sportTypeId={sportTypeId} isPickleballRating={isPickleballRating} isItGlobalSearch={isItGlobalSearch} data-testid={dataTestId && `${dataTestId}.utr`} />
            </div>
            <div className="title" data-testid={dataTestId && `${dataTestId}.label`}>
                <UtrLabel player={player} force={{ ratingType, utrType, typeDots: showTypeDots, hideUtrLabel }} sportTypeId={sportTypeId} isPickleballRating={isPickleballRating} hideReliableLabelForPkb={hideReliableLabelForPkb} isItGlobalSearch={isItGlobalSearch} data-testid={dataTestId && `${dataTestId}.label`} />
            </div>
        </div>
    );
};

Rating.propTypes = {
    isPickleballRating: PropTypes.bool,
    isItGlobalSearch: PropTypes.bool,
    showTypeDots: PropTypes.bool,
    'data-testid': PropTypes.string,
};
Rating.defaultProps = {
    isPickleballRating: false,
    isItGlobalSearch: false,
    showTypeDots: true,
    'data-testid': null,
};
export default Rating;
